import { VndlyAlert } from './VndlyAlert'

export const fetchWithAlerts = async (
  fetchMethod,
  url,
  body,
  successMessage,
  errorMessage,
  // errorResponseKey can either be an array of possible keys OR a single key
  errorResponseKey = 'error'
) =>
  fetchMethod(url, body)
    .then(response => {
      if (successMessage) VndlyAlert.toast.success.fire(successMessage)
      return response
    })
    .catch(response => {
      let resolvedErrorMessage = errorMessage

      if (!resolvedErrorMessage) {
        let errorKeys = errorResponseKey
        if (!Array.isArray(errorResponseKey)) {
          errorKeys = [errorResponseKey]
        }
        for (const key of errorKeys) {
          resolvedErrorMessage = response.body?.[key]
          if (resolvedErrorMessage) break
        }
      }

      VndlyAlert.unexpectedError.fire(resolvedErrorMessage && { text: resolvedErrorMessage })
      return { error: true }
    })
